import Punt from "./punt";

export default class CflKick extends Punt {
    constructor() {
        super();
        this.requiredData[0] = {
            ...this.requiredData[0],
            displayName: "Kicked By",
            title: "Kicked By"
        };
        this.requiredData[1] = {
            ...this.requiredData[1],
            displayName: "Kicked To",
            title: "Kicked To"
        };
    }

    getPredicate() {
        return "kicked";
    }
}
